function load_cart(){
	console.log('reload_mini_cart');
	$('.cart .products_container').load('index.php?route=common/cart/info .cart .products_container > div');
}


function openWin2($url) {
	myWin = open("http://www.facebook.com/sharer.php?u=" + $url, "displayWindow", "width=520,height=300,left=350,top=170,status=no,toolbar=no,menubar=no");
}
!function(d,s,id){
	var js,fjs=d.getElementsByTagName(s)[0];
	if(!d.getElementById(id))
	{js=d.createElement(s);js.id=id;js.src="//platform.twitter.com/widgets.js";
		fjs.parentNode.insertBefore(js,fjs);}}(document,"script","twitter-wjs");

function get_popup_purchase(product_id) {
	$.ajax({
		url: 'index.php?route=module/popup_purchase&product_id='+product_id,
		type: 'post',
		success: function(response) {
			// Add response in Modal body
			$('#modal_container_fastorder .modal-body').html(response);
			$('#modal_container_fastorder').modal();
			$("#popup_purchase_telephone").mask("+38 999 999 99 99");
			popup_purchase_buy();
		}
	});
};

function getURLVar(key) {
	var value = [];

	var query = String(document.location).split('?');

	if (query[1]) {
		var part = query[1].split('&');

		for (i = 0; i < part.length; i++) {
			var data = part[i].split('=');

			if (data[0] && data[1]) {
				value[data[0]] = data[1];
			}
		}

		if (value[key]) {
			return value[key];
		} else {
			return '';
		}
	}
}


function loacation() {
	location.reload();
}

/***popup_purchase functions******/
function masked(element, status) {
	if (status == true) {
		$('<div/>')
			.attr({ 'class':'masked' })
			.prependTo(element);
		$('<div class="masked_loading" />').insertAfter($('.masked'));
	} else {
		$('.masked').remove();
		$('.masked_loading').remove();
	}
}

function validate( input ) {
	input.value = input.value.replace( /[^\d,]/g, '' );
}

function popup_purchase_buy(){
	$('#popup-checkout-button').click(function() {
		masked('#popup-purchase-wrapper', true);
		$.ajax({
			type: 'post',
			url:  'index.php?route=module/popup_purchase/make_order',
			dataType: 'json',
			data: $('#purchase-form').serialize(),
			success: function(json) {


				if (json['error']) {
					if (json['error']['field']) {
						masked('#popup-purchase-wrapper', false);
						$('#popup-purchase-wrapper .text-danger').remove();
						$.each(json['error']['field'], function(i, val) {
							$('#popup-purchase-wrapper [name="' + i + '"]').addClass('error_style').after('<div class="text-danger">' + val + '</div>');
						});
					}

					if (json['error']['option']) {
						for (i in json['error']['option']) {
							masked('#popup-purchase-wrapper', false);
							$('#popup-purchase-wrapper .required .text-danger').remove();
							var element = $('#popup-purchase-wrapper #input-option' + i.replace('_', '-'));
							element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
						}
					}

					if (json['error']['recurring']) {
						$('#popup-purchase-wrapper select[name=\'recurring_id\']').after('<div class="text-danger">' + json['error']['recurring'] + '</div>');
					}

				} else {
					if (json['output']) {
						masked('#popup-purchase-wrapper', false);
						$('#popup-checkout-button').remove();
						$('#popup-purchase-wrapper .popup-center').html(json['output']);

					}
				}
			}
		});
	});

}

function sub_menu_container_3_width(){
	setTimeout(function(){
		let f_width = $('.header__bottom_block .container').width() - 60;
		let slm_width = $('.header__bottom_block .menu_container ul > li > .sub_menu_container ').width();
		let slm_height = $('.header__bottom_block .menu_container .sub_menu_container ').height();
		let m_width = f_width - slm_width;
		$('.menu_container .sub_menu_container .sub_menu_container_3').width(m_width);
		$('.menu_container .sub_menu_container .sub_menu_container_3').css("min-height",slm_height);
		//$('.menu_container .sub_menu_container .sub_menu_container_3').height(slm_height);

	}, 1000);
}


function customSelectInit(){
	//console.log('customSelectInit');
	$(".custom-select select").each(function() {
		if(!$(this).hasClass('is-customized')) {
			$(this).addClass('is-customized');
			var sb = new SelectBox({
				selectbox: $(this),
				customScrollbar: true,
				height: 300,
				changeCallback: function() {
					//alert("I was changed!");
				}

			});
		};
	});
}

function cartPaneDestroy(){

	$('.cart .products_container').each(function () {
		console.log('JCARDestroy');
		var pane = $(this);
		pane.jScrollPane();
		var api = pane.data('jsp');
		api.destroy();
		pane.jScrollPane();

	});

}

function cartPaneInit(){
	$('.cart .products_container').each(function () {
		setTimeout(function() {
			console.log('JCARTinit');
			var pane = $('.cart .products_container')
			pane.jScrollPane();
			var api = pane.data('jsp');
			pane.jScrollPane();
		}, 1000);
	})
}


function onlyDigit(){
	//console.log('only_digit');
	$(".qty_wrap input").keypress(function(e) { //if the letter is not digit then display error and don't type anything
		if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
			return false
		}
	});
}




/***************************************************************************************/
$(document).ready(function() {

	onlyDigit();

	$('.account-simpleedit #simplepage_form #edit_telephone').mask("+38 999 999 99 99");

	/* custom_select */

	customSelectInit();

	/*****************/

	cartPaneInit();


	/*****************/
	$('.header_phone_content .icon').click(function(){
		$('.header_phone_content .hidden_phones').toggleClass('open');
	});

	$('html').click(function() {
		$('.header_phone_content .hidden_phones').removeClass('open');
	});

	$('.header_phone_content').click(function(event){
		event.stopPropagation();
	});



	/* mobile_menu */

	if(Modernizr.mq('(max-width: 991px)')) {

		$('#hidden_mob_menu a.with_sub_menu_link_mm').click(function(e){
			e.preventDefault();
			$('#hidden_mob_menu .hidden_mob_menu_menu_content').addClass('open_submenu');
			$(this).next().addClass('open');

		});

		$('#hidden_mob_menu a.back').click(function(e){
			e.preventDefault();
			$(this).closest('.sub_menu_container').removeClass('open');
		});

		$('a.back_third_lvl').click(function(){
			$('#hidden_mob_menu .hidden_mob_menu_menu_content').removeClass('open_submenu');
		})

		$('#mob_menu_close').click(function(){
			$('#hidden_mob_menu .hidden_mob_menu_menu_content').removeClass('open_submenu');
			$('#hidden_mob_menu .sub_menu_container').removeClass('open');
		});

	}/*if(Modernizr.mq('(max-width: 991px)')) {*/


	/*******************/

	//sub_menu_container_3 _ width
	if(Modernizr.mq('(min-width: 992px)')) {
		sub_menu_container_3_width();

		$(window).resize(function() {
			sub_menu_container_3_width();
		});
	}
	/**********************************/

	/*Open/close mobile_menu*/
	$('.mob_ham').click(function(){
		$('body').addClass('mob_menu_open');
		$('#hidden_meny_overlay').addClass('active');
		$('#hidden_mob_menu').addClass('active');
	});

	$('#mob_menu_close').click(function(){
		$('body').removeClass('mob_menu_open');
		$('#hidden_meny_overlay').removeClass('active');
		$('#hidden_mob_menu').removeClass('active');
	});

	/*Open/close footer accordion */
	$('.footer_accordeon .item .item_heading .icon').click(function(){
		//$('.footer_accordeon .item').removeClass('open');
		$(this).parents('.item').toggleClass('open');
	});


	/*Fixed_menu*/

	$(window).scroll(function() {
		if ($(this).scrollTop() > 180) {
			$('header').addClass('fixed');
			$('.maincontent').addClass('header_fixed');
		} else {
			$('header').removeClass('fixed');
			$('.maincontent').removeClass('header_fixed');
		}
	});


	$('.main_slideshow_bottom_title span').click(function(){
		$('.header__autorize a.quick_login').click();
	});

	/****************************************************************/
		$('.header__autorize_logged .customer_name').hover(function(){
			console.log('1');
			$('.header__autorize_logged .customer_content').addClass('open');
		});

		$('html').click(function() {
			$('.header__autorize_logged .customer_content').removeClass('open');
		});

		$('.header__autorize_logged .customer_name').click(function(event){
			event.stopPropagation();
		});


	/****************************************************************/
		let product_limit = $('#input-limit option:selected').text();
		$('.visible_products').text(product_limit);

		$( "#input-limit" ).change(function() {
			$('.visible_products').text(product_limit);
		});
	/****Fake reset filter************************************************************/
	$('.mfilter-box .mega_filter_heading .reset_filter').click(function() {
		$('.mfilter-box .mfilter-button-reset').click();
	});


	/**Showmore_button_**************************************************/
	if($('.products_row').length){
		showmorebutton();
	}
	/*****************************************************************/

	/* Simpla remove q-ty block in mobile view*/
	if(Modernizr.mq('(max-width: 767px)')) {
		$(".bottom_line .quantity .input-group").appendTo("#mobile_quantity .quantity");
	}

	/*Simpla phone masked*/
	$(".simplecheckout input[type=tel]").mask("+38 999 999 99 99");


	/***************************************************************************************/
	$(document).on('click', '.а_checkout', function () {
		$('#simplecheckout_button_confirm').click();
		$('.simplecheckout .simplecheckout-button-block .simplecheckout-button-left input').click();
	});

	/************ Mobile sort and limits ***************************************************/
	$('#mobile_sorting input').change(function(){
		location = $(this).val();
	})

	$('#mobile_sorting .block_title .ico').click(function(){

		$(this).parent().next().toggleClass('hidden');

		if($(this).text()=='-'){
			$(this).text('+');
		} else {
			$(this).text('-');
		}

	})

	/*SORT*/
	$("body").on("click", ".open_sort", function() {
		$('#mobile_sorting').addClass('open');
	});
	$('#mobile_sorting .filter_close_buttons .filter_close').click(function(){
		$('#mobile_sorting').removeClass('open');
	})


	/**************Show filter/sortblock on tablets phones ********************************/
	$("body").on("click", ".open_filter", function() {
		$('.mfilter-free-container').addClass('open');
	});


	$('.filter_close_buttons .filter_close').click(function(){
		$('.mfilter-free-container').removeClass('open');
	});


	$('.header__bottom_block .ham').click(function(){
		$(this).toggleClass('open');
		$('#hidden_menu').toggleClass('open');
	});

	/************************Active menus item***************************************************************/
	var infomenu = $('.header__info_menu ul');

	infomenu.find('li a').each(function () {
		if ($(location).attr('href').indexOf($(this).attr('href')) >= 0){
			$(this).addClass('active');
			return;
		}
	});
	/******/
	if($('.account-list').length){
		var accauntmenu = $('.account-list ul');

		accauntmenu.find('li a').each(function () {
			if ($(location).attr('href').indexOf($(this).attr('href')) >= 0){
				$(this).addClass('active');
				return;
			}
		});
	}
	/****************Quick_register/login***************************************************/
	$('.header__autorize_logged').click(function(){
		$('.header__autorize_logged .customer_content').toggleClass('open');
	});



	$('html').click(function() {
		$('.header__autorize_logged .customer_content').removeClass('open');
	});

	$('.header__autorize_logged').click(function(event){
		event.stopPropagation();
	});


	/**********/
	$('.main_slideshow_bottom_title span').click(function(){
		$('.header__bottom_block a.quick_login').click();
	})


	/****************************************************************************************/
	//Скрытое переключение табов

	$('#autorization_modal .login_block span').click(function(){
		$('#autorization_modal .nav-tabs li.login a').click();
	});

	$('#autorization_modal #quick-login span').click(function(){
		$('#autorization_modal .nav-tabs li.register a').click();
	});

	/**************/

	$("#input-telephone").mask("+38 999 999 99 99");
	$("#input-telephone-l").mask("+38 999 999 99 99");


	$('a.quick_login').click(function() {
		$('#autorization_modal').modal('show');
		console.log('quick_login_click');
	});


	$('#quick-register input').on('keydown', function(e) {
		if (e.keyCode == 13) {
			$('#quick-register .createaccount').trigger('click');
		}
	});


	$('#quick-register .createaccount').click(function() {
		$('#autorization_modal .modal-body .tab-content .form-group label.error').remove();

		$.ajax({
			url: 'index.php?route=common/quicksignup/register',
			type: 'post',
			data: $('#quick-register input[type=\'radio\']:checked, #quick-register input[type=\'text\'], #quick-register input[type=\'password\'], #quick-register input[type=\'checkbox\']:checked'),
			dataType: 'json',
			beforeSend: function() {
				$('#quick-register .createaccount').button('loading');
				$('#autorization_modal .alert-danger').remove();
			},
			complete: function() {
				$('#quick-register .createaccount').button('reset');
			},
			success: function(json) {

				//console.log(json);

				$('#autorization_modal .form-group').removeClass('has-error');

				if(json['islogged']){
					window.location.href="index.php?route=account/account";
				}
				if (json['error_name']) {
					$('#quick-register #input-name-r').parent().addClass('has-error');
					$('#quick-register #input-name-r').focus();
					$('#quick-register #input-name-r').parent().append('<label class="error">' + json['error_name'] + '</label>');
				}
				if (json['error_lastname']) {
					$('#quick-register #input-lastname').parent().addClass('has-error');
					$('#quick-register #input-lastname').focus();
					$('#quick-register #input-lastname').parent().append('<label class="error">' + json['error_lastname'] + '</label>');
				}

				if (json['error_email']) {
					$('#quick-register #input-email-r').parent().addClass('has-error');
					$('#quick-register #input-email-r').focus();
					$('#quick-register #input-email-r').parent().append('<label class="error">' + json['error_email'] + '</label>');
				}
				if (json['error_telephone']) {
					$('#quick-register #input-telephone').parent().addClass('has-error');
					$('#quick-register #input-telephone').focus();
					$('#quick-register #input-telephone').parent().append('<label class="error">' + json['error_telephone'] + '</label>');
				}
				if (json['error_password']) {
					$('#quick-register #input-password-r').parent().addClass('has-error');
					$('#quick-register #input-password-r').focus();
					$('#quick-register #input-password-r').parent().append('<label class="error">' + json['error_password'] + '</label>');

				}

				//Compare passwords
				let pass = $('#autorization_modal #input-password-r').val();
				let repass = $('#autorization_modal #input-repassword-r').val();

				if (pass != repass){
					$('#quick-register #input-password-r').parent().addClass('has-error');
					$('#quick-register #input-repassword-r').parent().addClass('has-error');
					$('#quick-register #input-repassword-r').focus();
					$('#quick-register #input-repassword-r').parent().append('<label class="error">Не співпадають паролі</label>');
					return
				}

				if (json['error_agree']) {
					$('#quick-register .agree_buttons_block').addClass('has-error');
					$('#quick-register .agree_buttons_block .agree_block').append('<label class="error">' + json['error_agree'] + '</label>');

				}

				/*if (json['error']) {
					$('#autorization_modal .modal-body .tab-content').prepend('<div class="alert alert-danger" style="margin:5px;"><i class="fa fa-exclamation-circle"></i> ' + json['error'] + '</div>');
				}*/

				if (json['now_login']) {
					//$('.quick-login').before('<li class="dropdown"><a href="<?php echo $account; ?>" title="<?php echo $text_account; ?>" class="dropdown-toggle" data-toggle="dropdown"><i class="fa fa-user"></i> <span class="hidden-xs hidden-sm hidden-md"><?php echo $text_account; ?></span> <span class="caret"></span></a><ul class="dropdown-menu dropdown-menu-right"><li><a href="<?php echo $account; ?>"><?php echo $text_account; ?></a></li><li><a href="<?php echo $order; ?>"><?php echo $text_order; ?></a></li><li><a href="<?php echo $transaction; ?>"><?php echo $text_transaction; ?></a></li><li><a href="<?php echo $download; ?>"><?php echo $text_download; ?></a></li><li><a href="<?php echo $logout; ?>"><?php echo $text_logout; ?></a></li></ul></li>');

					$('.quick-login').remove();

					/*setTimeout(function {
                        //document.location.reload(true);
                    }, 500);*/

					$('#autorization_modal .modal-header .close').click(function(){

						setTimeout(function () {
							document.location.reload(true);
						}, 1300)

					})

				}
				if (json['success']) {
					// $('#autorization_modal .modal-header').append(json['heading_title']);
					success = json['text_message'];
					success += '<div class="buttons text-center"><a onclick="loacation();" class="button">'+ json['button_continue'] +'</a></div>';
					$('#autorization_modal .modal-body').html('<div class="success">' + json['heading_title'] + success + '</div>');
				}
			}
		});
	});

	$('#quick-register .generate_code_sms').click(function() {
		$.ajax({
			url: 'index.php?route=common/quicksignup/generate_code_quick',
			type: 'post',
			data: $('#quick-register input[name="telephone"]'),
			dataType: 'json',
			beforeSend: function() {
				$('#quick-register button[type="button"]').button('loading');
				$('#quick-register .alert-danger').remove();
				$('#quick-register .alert-success').remove();
				$('#quick-register .form-group').removeClass('has-error');
			},
			complete: function() {
				$('#quick-register button[type="button"]').button('reset');
			},
			success: function(json) {
				if (json['error_telephone']) {
					$('#quick-register #input-telephone').parent().addClass('has-error');
					$('#quick-register #input-telephone').focus();
				}
				if (json['error']) {
					$('#quick-register').prepend('<div class="alert alert-danger">' + json['error'] + '</div>');
				}
				if (json['body']) {
					$('#quick-register').prepend('<div class="alert alert-success">' + json['body'] + '</div>');
				}

			}

		});
	});


	$('#quick-login input').on('keydown', function(e) {
		if (e.keyCode == 13) {
			$('#quick-login .loginaccount').trigger('click');
		}
	});


	$('#quick-login .loginaccount').click(function() {
		$.ajax({
			url: 'index.php?route=common/quicksignup/login',
			type: 'post',
			data: $('#quick-login input[type=\'text\'], #quick-login input[type=\'password\']'),
			dataType: 'json',
			beforeSend: function() {
				$('#quick-login .loginaccount').button('loading');
				$('#autorization_modal .alert-danger').remove();
			},
			complete: function() {
				$('#quick-login .loginaccount').button('reset');
			},
			success: function(json) {
				$('#autorization_modal .form-group').removeClass('has-error');
				if(json['islogged']){
					window.location.href="index.php?route=account/account";
				}

				if (json['error']) {
					$('#autorization_modal .modal-body .tab-content').prepend('<div class="alert alert-danger" style="margin:5px;"><i class="fa fa-exclamation-circle"></i> ' + json['error'] + '</div>');
					$('#quick-login #input-telephone-l').parent().addClass('has-error');
					$('#quick-login #input-password-l').parent().addClass('has-error');
					$('#quick-login #input-telephone-l').focus();
				}
				if(json['success']){
					loacation();
					$('#autorization_modal').modal('hide');
				}

			}
		});
	});
	/****************Main slideshow*************************************************************************/
	if($('#main_slideshow').length) {

		var $status = $('.custom_paging');
		var $slickElement = $('#main_slideshow');

		$slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
			//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
			if(!slick.$dots){
				return;
			}

			var i = (currentSlide ? currentSlide : 0) + 1;
			$status.html('<span>0' + i + '</span>' + '&nbsp;/&nbsp;' + '0' + (slick.$dots[0].children.length));
		});


		$('#main_slideshow').slick({
			prevArrow: '<span class="icon icon-arrow_left"></span>',
			nextArrow: '<span class="icon icon-arrow_right"></span>',
			dots: true,
			autoplay: true,
			autoplaySpeed: 4000,
			/*dotsClass: 'custom_paging',
            customPaging: function (slider, i) {
                //FYI just have a look at the object to find aviable information
                //press f12 to access the console
                //you could also debug or look in the source
                //console.log(slider);
                return '<span>0' + (i + 1) + '</span>' + '&nbsp;/&nbsp;' + '0' + slider.slideCount;
            }*/
		});
	};


	/***********************Slider Product Page********************************************/
	if ($('.product-big-image.gallery').length){
		$('.product-big-image.gallery').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			fade: true,
			asNavFor: '.image-additional',
			prevArrow: '<span class="ani icon icon-arrow-left"></span>',
			nextArrow: '<span class="ani icon icon-arrow-right"></span>',
		});
		$('.image-additional').slick({
			slidesToShow: 6,
			slidesToScroll: 1,
			asNavFor: '.product-big-image',
			arrows: false,
			dots: false,
			centerMode: false,
			focusOnSelect: true,
			responsive: [
				{
					breakpoint: 1025,
					settings: {
						slidesToShow: 5,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1
					}
				}
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			]

		});
		$('.product-big-image.gallery a').magnificPopup({
			type:'image',
			gallery: {
				enabled: true
			}
		});

	};


	if ($('.product-big-image').length){
		$('.product-big-image a.popup').magnificPopup({
			type:'image',
			gallery: {
				enabled: false
			}
		});

		$("body").on("click", ".mp", function() {
			$(this).prev().click();
		})
	}
	/*******************************************************************************************************/
	$('.shares_block_container button.shares_button').click(function(){
		$('.shares_block_container .share_block').toggleClass('open');
	});

	$('.shares_block_container .share_block .cls').click(function(){
		$('.shares_block_container .share_block').removeClass('open');
	});



	$('html').click(function() {
		$('.shares_block_container .share_block').removeClass('open');
	});
	$('.shares_block_container button.shares_button').click(function(event){
		event.stopPropagation();
	});
	$('.shares_block_container .share_block').click(function(event){
		event.stopPropagation();
	})
	/*******************************************************************************************************/

	$(document).on('click', '.qty_wrap .bnt_plus', function () {
		var num = parseInt($(this).prev().val());
		var available_qty = parseInt($(this).prev().data('qty'));
		var min = parseInt($(this).prev().data('min'));
		$(this).prev().val(num + min);
	});


	$(document).on('click', '.qty_wrap .bnt_minus', function () {
		if ($(this).next().val() > $(this).next().data('min')) {
			var num = parseInt($(this).next().val());
			$(this).next().val(num - parseInt($(this).next().data('min')))
		}
	});

	/*$(document).on('click', '.product-layout .buy_button', function () {
		//console.log('in_partial');
		var product_id = parseInt($(this).prev().find('input[name=quantity]').data('id'));
		//console.log(product_id);
		var qty = parseInt($(this).prev().find('input[name=quantity]').val());
		//console.log(qty);
		cart.add(product_id, qty);
	});


	$(document).on('click', '#product .buy_button', function () {
		console.log('in_product');
		var product_id = parseInt($(this).parent().prev().find('input[name=quantity]').data('id'));
		//console.log(product_id);
		var qty = parseInt($(this).parent().prev().find('input[name=quantity]').val());
		//console.log(qty);
		cart.add(product_id, qty);
	});*/

	/********************Callback**********************************************/
	$("#input-phone-callback").mask("+38 999 999 99 99");

	$('#request_call-btn').on('click', function () {
		$.ajax({
			url: 'index.php?route=sendmess/send_message/send',
			type: 'post',
			dataType: 'json',
			data:  $("#request_call-form").serialize(),
			beforeSend: function () {
				if ($("textarea").is("#g-recaptcha-response")) {
					grecaptcha.reset();
				}
				$('#request_call-btn').button('loading');
			},
			complete: function () {
				$('#request_call-btn').button('reset');
			},
			success: function (json) {
				if (json['error']) {
					$('.error').remove();
					$('#request_call-form .input_container').removeClass('has_error');
					if (json['error_name']){
						$('#request_call-form input[name="name"]').after('<label class="error">' + json['error_name'] + '</label>');
						//$('#request_call-form input[name="name"]').parent().parent('.form-group').addClass('has-error');
					}
					if (json['error_phone']){
						$('#request_call-form input[name="phone"]').after('<label class="error">' + json['error_phone'] + '</label>');
						$('#request_call-form input[name="phone"]').parents('.input_container').addClass('has_error');
						//$('#request_call-form input[name="phone"]').parent().parent('.form-group').addClass('has-error');
					}
				}
				if (json['success']) {
					$('#request_call-form .input_container').removeClass('has_error');
					$('#request_call-form .error').remove();
					//$('input[name=\'name\']').val('');
					$('input[name=\'phone\']').val('');

					$('#request_call-modal').modal('hide');

					$('#modal_info_container .modal-body').html(json['success']);
					$('#modal_info_container').modal();
					//$('header').before('<div class="user_message_wrapp" style="opacity: 0"><div class="container alert alert-success"><i class="fa fa-check-circle"></i> ' + json['success'] + ' <button type="button" class="close">&times;</button></div></div>');
					$('.user_message_wrapp').animate({
						opacity: 1
					}, 300);
				}
			}
		});
	});

	/************************************************************************************************************/
	$('.facebook a').click(function (e) {
		e.preventDefault();
	});
	/******************************************************************/

	$('.open-popup-link').magnificPopup({
		closeMarkup: '<button title="%title%" class="mfp-close icon icon-x"></button>',
		type:'inline',
		midClick: false // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
	});


	/**********************************************************************/
	// Highlight any found errors
	$('.text-danger').each(function() {
		var element = $(this).parent().parent();

		if (element.hasClass('form-group')) {
			element.addClass('has-error');
		}
	});


	/*****************************************************************************************************/
	/* Search */

	$('.search_header_content input[name=\'search-input\']').prev().on('click', function () {
		console.log('header_search_init');
		url = $('base').attr('href') + 'index.php?route=product/search';
		//var value = $('header input[name=\'search\']').val();
		var value = $('.search_header_content input[name=\'search-input\']').val();

		if (value) {
			url += '&search=' + encodeURIComponent(value);
		}

		location = url;
	});

	$('.search_header_content input[name=\'search-input\']').on('keydown', function (e) {
		if (e.keyCode == 13) {
			$(this).prev().trigger('click');

		}
	});

	/***************Search page*************************************************************************************/
	$('#button-search-add').click(function(){
		$('#button-search').click();
	});

	$('#button-search').bind('click', function () {
			console.log('bindSearch');
			url = 'index.php?route=product/search';

		var search = $('#content input[name=\'search-input\']').prop('value');

			if (search) {
				url += '&search=' + encodeURIComponent(search);
			}

			var category_id = $('.search_page_action_block select[name=\'category_id\']').prop('value');

			if (category_id > 0) {
				url += '&category_id=' + encodeURIComponent(category_id);
			}

			var sub_category = $('#content input[name=\'sub_category\']:checked').prop('value');

			if (sub_category) {
				url += '&sub_category=true';
			}

			var filter_description = $('#content input[name=\'description\']:checked').prop('value');

			if (filter_description) {
				url += '&description=true';
			}

			location = url;
		});

		$('#content input[name=\'search-input\']').bind('keydown', function (e) {
			if (e.keyCode == 13) {
				$('#button-search').trigger('click');
			}
		});

		$('select[name=\'category_id\']').on('change', function () {
			if (this.value == '0') {
				$('input[name=\'sub_category\']').prop('disabled', true);
			} else {
				$('input[name=\'sub_category\']').prop('disabled', false);
			}
		});

		$('select[name=\'category_id\']').trigger('change');


	/********************************************************************************************************/
	$("body").on("click", "#grid-view", function() {
		//console.log('grid-view');
		$('.filtering_block .view_block button').removeClass('active');
		$(this).addClass('active');
		$('#content .products_row').removeClass().addClass('row products_row');
		$('#content .products_row').addClass('grid-view');
		localStorage.setItem('display', 'grid-view');
	});

	// Product list-view
	$("body").on("click", "#list-view", function() {
		//console.log('list-view');
		$('.filtering_block .view_block button').removeClass('active');
		$(this).addClass('active');
		$('#content .products_row').removeClass().addClass('row products_row');
		$('#content .products_row').addClass('list-view');
		localStorage.setItem('display', 'list-view');
	});






	if (localStorage.getItem('display') == 'grid-view') {
		$('#grid-view').trigger('click');
	}else{
		$('#list-view').trigger('click');
	};



	// Checkout
	$(document).on('keydown', '#collapse-checkout-option input[name=\'email\'], #collapse-checkout-option input[name=\'password\']', function(e) {
		if (e.keyCode == 13) {
			$('#collapse-checkout-option #button-login').trigger('click');
		}
	});

	// tooltips on hover
	//$('[data-toggle=\'tooltip\']').tooltip({container: 'body',trigger: 'hover'});

	// Makes tooltips work on ajax generated content
	/*$(document).ajaxStop(function() {
		$('[data-toggle=\'tooltip\']').tooltip({container: 'body'});
	});*/
});

/******************************************************************/
if($('#newsletter').length) {
	$('#lt_newsletter_form').submit(function () {
		$.ajax({
			type: 'post',
			url: 'index.php?route=module/lt_newsletter/subscribe',
			data: $("#lt_newsletter_form").serialize(),
			dataType: 'json',
			beforeSend: function () {
				//$('.btn-newsletter').attr('disabled', true).button('loading');
			},
			complete: function () {
				$('.btn-newsletter').attr('disabled', false).button('reset');
			},
			success: function (json) {
				$('.alert, .text-danger').remove();
				$('.form-group').removeClass('has-error');

				if (json.error) {
					$('#lt_newsletter_form #lt_newsletter_email').after('<label class="error">' + json.error + '</label>');
				} else {
					$('#thanksModal .modal-body .modal-title').html(json.text_subscribed_title);
					$('#thanksModal .modal-body .modal_content').html(json.success);
					$('#thanksModal').modal('show');

					//$('#lt_newsletter_form').after('<div class="alert alert-success newsletter-msg">' + json.success + '<button type="button" class="close" data-dismiss="alert">&times;</button></div>');

					$('#lt_newsletter_email').val('');
				}
			}

		});
		return false;
	});
}

/******************************************************************/
// Cart add remove functions
/*var cart = {
	'add': function(product_id, quantity) {
		$.ajax({
			url: 'index.php?route=checkout/cart/add',
			type: 'post',
			data: 'product_id=' + product_id + '&quantity=' + (typeof(quantity) != 'undefined' ? quantity : 1),
			dataType: 'json',
			beforeSend: function() {
				//$('#cart > button').button('loading');
			},
			complete: function() {
				$('.cart > button').button('reset');
			},
			success: function(json) {
				$('.alert, .text-danger').remove();

				if (json['redirect']) {
					location = json['redirect'];
				}

				if (json['success']) {

					//$('#content').parent().before('<div class="alert alert-success"><i class="fa fa-check-circle"></i> ' + json['success'] + ' <button type="button" class="close" data-dismiss="alert">&times;</button></div>');

					// Need to set timeout otherwise it wont update the total
					setTimeout(function () {
						$('#info_popup_addcart .info_popup_content .text .content').html(json['product']);
						$('.cart').addClass('active');
						$('.cart > button').html('<i class="icon icon-cart ani"></i><span class="cart-total">' + json['total'] + '</span>');
					}, 100);

					//$('html, body').animate({ scrollTop: 0 }, 'slow');

					$('#info_popup_addcart').addClass('open');

					setTimeout(function () {
						$('#info_popup_addcart .right_col .text .content').html('');
						$('#info_popup_addcart').removeClass('open');
					}, 3000);

					$('.cart .products_container').load('index.php?route=common/cart/info .cart .products_container > div');
				}
			},
			error: function(xhr, ajaxOptions, thrownError) {
				alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
			}
		});
	},
	'update': function(key, quantity) {
		$.ajax({
			url: 'index.php?route=checkout/cart/edit',
			type: 'post',
			data: 'key=' + key + '&quantity=' + (typeof(quantity) != 'undefined' ? quantity : 1),
			dataType: 'json',
			beforeSend: function() {
				//$('#cart > button').button('loading');
			},
			complete: function() {
				$('#cart > button').button('reset');
			},
			success: function(json) {
				// Need to set timeout otherwise it wont update the total
				setTimeout(function () {
					$('#cart > button').html('<i class="icon icon-cart ani"></i><span id="cart-total">' + json['total'] + '</span>');
				}, 100);

				if (getURLVar('route') == 'checkout/cart' || getURLVar('route') == 'checkout/checkout') {
					location = 'index.php?route=checkout/cart';
				} else {
					$('.cart .products_container').load('index.php?route=common/cart/info .cart .products_container > div');
				}
			},
			error: function(xhr, ajaxOptions, thrownError) {
				alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
			}
		});
	},
	'remove': function(key) {
		$.ajax({
			url: 'index.php?route=checkout/cart/remove',
			type: 'post',
			data: 'key=' + key,
			dataType: 'json',
			beforeSend: function() {
				//$('.cart > button').button('loading');
			},
			complete: function() {
				$('.cart > button').button('reset');
			},
			success: function(json) {
				// Need to set timeout otherwise it wont update the total
				setTimeout(function () {
					$('.cart > button').html('<i class="icon icon-cart ani"></i><span class="cart-total">' + json['total'] + '</span>');
				}, 100);

				if (getURLVar('route') == 'checkout/cart' || getURLVar('route') == 'checkout/checkout') {
					location = 'index.php?route=checkout/cart';
				} else {
					$('.cart .products_container').load('index.php?route=common/cart/info .cart .products_container > div');
				}
			},
			error: function(xhr, ajaxOptions, thrownError) {
				alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
			}
		});
	}
}
*/
var voucher = {
	'add': function() {

	},
	'remove': function(key) {
		$.ajax({
			url: 'index.php?route=checkout/cart/remove',
			type: 'post',
			data: 'key=' + key,
			dataType: 'json',
			beforeSend: function() {
				//$('#cart > button').button('loading');
			},
			complete: function() {
				$('.cart > button').button('reset');
			},
			success: function(json) {
				// Need to set timeout otherwise it wont update the total
				setTimeout(function () {
					$('.cart > button').html('<i class="icon icon-icon_cart ani"></i><span class="cart-total">' + json['total'] + '</span>');
				}, 100);

				if (getURLVar('route') == 'checkout/cart' || getURLVar('route') == 'checkout/checkout') {
					location = 'index.php?route=checkout/cart';
				} else {
					$('.cart > ul').load('index.php?route=common/cart/info ul li');
				}
			},
			error: function(xhr, ajaxOptions, thrownError) {
				alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
			}
		});
	}
}

var wishlist = {
	'add': function(product_id) {
		$.ajax({
			url: 'index.php?route=account/wishlist/add',
			type: 'post',
			data: 'product_id=' + product_id,
			dataType: 'json',
			success: function(json) {
				$('.alert').remove();

				if (json['redirect']) {
					location = json['redirect'];
				}

				if (json['success']) {
					//$('#content').parent().before('<div class="alert alert-success"><i class="fa fa-check-circle"></i> ' + json['success'] + ' <button type="button" class="close" data-dismiss="alert">&times;</button></div>');


					var list, index;
					list = document.getElementsByClassName('wishlist-'+product_id);
					for (index = 0; index < list.length; ++index) {
						list[index].setAttribute('disabled', 'disabled');
					}

					$('.header__wishlist_container .wishlist-total-counter').html(json['total']);
					$('.header__wishlist_container .wishlist-total-counter').addClass('active');

					$('#info_popup_wishlist').addClass('open');

					setTimeout(function () {
						$('#info_popup_wishlist').removeClass('open');
					}, 2000);

					//$('html, body').animate({ scrollTop: 0 }, 'slow');


				}


			},
			error: function(xhr, ajaxOptions, thrownError) {
				alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
			}
		});
	},
	'remove': function() {

	}
}

var compare = {
	'add': function(product_id) {
		$.ajax({
			url: 'index.php?route=product/compare/add',
			type: 'post',
			data: 'product_id=' + product_id,
			dataType: 'json',
			success: function(json) {
				$('.alert').remove();

				if (json['success']) {
					//$('#content').parent().before('<div class="alert alert-success"><i class="fa fa-check-circle"></i> ' + json['success'] + ' <button type="button" class="close" data-dismiss="alert">&times;</button></div>');


					var list, index;
					list = document.getElementsByClassName('compare-'+product_id);
					for (index = 0; index < list.length; ++index) {
						list[index].setAttribute('disabled', 'disabled');
					}


					$('.header__compare_container .compare-total').html(json['total']);
					$('.header__compare_container .compare-total').addClass('active');
					$('#info_popup_compare').addClass('open');

					setTimeout(function () {
						$('#info_popup_compare').removeClass('open');
					}, 2000);


					//$('html, body').animate({ scrollTop: 0 }, 'slow');
				}
			},
			error: function(xhr, ajaxOptions, thrownError) {
				alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
			}
		});
	},
	'remove': function() {

	}
}

$('.info_popup .icon-x').click(function(){
	$(this).parent().removeClass('open');
})


/* Agree to Terms */
$(document).delegate('.agree', 'click', function(e) {
	e.preventDefault();

	$('#modal-agree').remove();

	var element = this;

	$.ajax({
		url: $(element).attr('href'),
		type: 'get',
		dataType: 'html',
		success: function(data) {
			html  = '<div id="modal-agree" class="modal">';
			html += '  <div class="modal-dialog modal-dialog-centered">';
			html += '    <div class="modal-content">';
			html += '      <div class="modal-header">';
			html += '        <button type="button" class="close" data-dismiss="modal" aria-label="Close">' +
				'                    <span aria-hidden="true" class="icon icon-icon_close_buble_mobile"></span>' +
				'                </button>';
			html += '        <h3 class="modal-title">' + $(element).text() + '</h3>';
			html += '      </div>';
			html += '      <div class="modal-body">' + data + '</div>';
			html += '    </div';
			html += '  </div>';
			html += '</div>';

			$('body').append(html);

			$('#modal-agree').modal('show');
		}
	});
});

// Autocomplete */
(function($) {
	$.fn.autocomplete = function(option) {
		return this.each(function() {
			this.timer = null;
			this.items = new Array();

			$.extend(this, option);

			$(this).attr('autocomplete', 'off');

			// Focus
			$(this).on('focus', function() {
				this.request();
			});

			// Blur
			$(this).on('blur', function() {
				setTimeout(function(object) {
					object.hide();
				}, 200, this);
			});

			// Keydown
			$(this).on('keydown', function(event) {
				switch(event.keyCode) {
					case 27: // escape
						this.hide();
						break;
					default:
						this.request();
						break;
				}
			});

			// Click
			this.click = function(event) {
				event.preventDefault();

				value = $(event.target).parent().attr('data-value');

				if (value && this.items[value]) {
					this.select(this.items[value]);
				}
			}

			// Show
			this.show = function() {
				var pos = $(this).position();

				$(this).siblings('ul.dropdown-menu').css({
					top: pos.top + $(this).outerHeight(),
					left: pos.left
				});

				$(this).siblings('ul.dropdown-menu').show();
			}

			// Hide
			this.hide = function() {
				$(this).siblings('ul.dropdown-menu').hide();
			}

			// Request
			this.request = function() {
				clearTimeout(this.timer);

				this.timer = setTimeout(function(object) {
					object.source($(object).val(), $.proxy(object.response, object));
				}, 200, this);
			}

			// Response
			this.response = function(json) {
				html = '';

				if (json.length) {
					for (i = 0; i < json.length; i++) {
						this.items[json[i]['value']] = json[i];
					}

					for (i = 0; i < json.length; i++) {
						if (!json[i]['category']) {
							html += '<li data-value="' + json[i]['value'] + '"><a href="#">' + json[i]['label'] + '</a></li>';
						}
					}

					// Get all the ones with a categories
					var category = new Array();

					for (i = 0; i < json.length; i++) {
						if (json[i]['category']) {
							if (!category[json[i]['category']]) {
								category[json[i]['category']] = new Array();
								category[json[i]['category']]['name'] = json[i]['category'];
								category[json[i]['category']]['item'] = new Array();
							}

							category[json[i]['category']]['item'].push(json[i]);
						}
					}

					for (i in category) {
						html += '<li class="dropdown-header">' + category[i]['name'] + '</li>';

						for (j = 0; j < category[i]['item'].length; j++) {
							html += '<li data-value="' + category[i]['item'][j]['value'] + '"><a href="#">&nbsp;&nbsp;&nbsp;' + category[i]['item'][j]['label'] + '</a></li>';
						}
					}
				}

				if (html) {
					this.show();
				} else {
					this.hide();
				}

				$(this).siblings('ul.dropdown-menu').html(html);
			}

			$(this).after('<ul class="dropdown-menu"></ul>');
			$(this).siblings('ul.dropdown-menu').delegate('a', 'click', $.proxy(this.click, this));

		});
	}
})(window.jQuery);
